import { getFormattedCurrency } from '@core/Utils/Intl/GetFormattedCurrency';
import { Typography } from '@gds/Typography/Typography';

import type { LeasingVehiclePricingProps } from 'Components/LeasingVehicleAttributes/LeasingVehicleAttributes.entity';

import styles from './LeasingPrice.module.css';

const LeasingPrice = ({ locale, leasingPrice, strings }: LeasingVehiclePricingProps) => {
  const { vatMth, vatInitial } = leasingPrice;

  if (!vatMth || !vatInitial) return null;

  return (
    <div>
      <div className={styles.leasingPrice}>
        <Typography variant="body2" className={styles.leasingPrice}>
          {strings.from}
        </Typography>
      </div>
      <div className={styles.leasingPrice}>
        <Typography variant="h3" className={styles.priceContent}>
          {getFormattedCurrency(vatMth, locale)}
        </Typography>

        <Typography variant="body3" className={styles.leasingPriceText}>
          {strings.vat}
        </Typography>
      </div>
      <div className={styles.leasingPrice}>
        <Typography variant="body3" className={styles.leasingPriceText}>
          {strings.initial}
        </Typography>

        <Typography variant="body3" className={styles.priceContent}>
          {getFormattedCurrency(vatInitial, locale)}
        </Typography>
      </div>
    </div>
  );
};

export default LeasingPrice;
